import { req , contentTYPE_JSON ,baseURL,reqPostForDownload } from './axiosCreator'

const service = "/ExamService"

//获取用户基础检查信息
export const getExamBasicCheck = ( params ) => { return req( 'get', service+"/getExamBasicCheck" + '/' + params )}

//获取用户检测基础问询信息pull
export const getExamBasicQuery = ( params ) => { return req( 'get', service+"/getExamBasicQuery" + '/' + params )}

//获取用户心电信息
export const getExamEcg = ( params ) => { return req( 'get', service+"/getExamEcg" + '/' + params )}

//获取用户EMC信息
export const getExamEmc = ( params ) => { return req( 'get', service+"/getExamEmc" + '/' + params )}

//获取用户HyperQ信息
export const getExamHyperq = ( params ) => { return req( 'get', service+"/getExamHyperq" + '/' + params )}

//获取用户HyperQRest信息
export const getExamHyperqRest = ( params ) => { return req( 'get', service+"/getExamHyperqRest" + '/' + params )}

//获取文件
// /web/api/ExamService/download/{examUuid}/{fileType}      params = "examUuid/bsp"
export const download = ( params ) => { return `${baseURL}${service}/download/${params}` }

//获取新版EMC信息接口
// /web/api/ExamService/getExamEmcNew/{examUuid}
export const getExamEmcNew = ( params ) => { return req( 'get', service+"/getExamEmcNew" + '/' + params )}





//POST  ---------------------------------------------------------------------------------------------------------------------------

//更新用户基础检查信息
export const updateExamBasicCheck = ( params ) => { return req( 'post', service+"/updateExamBasicCheck" , params ,contentTYPE_JSON)}

//更新用户问询信息
export const updateExamBasicQuery = ( params ) => { return req( 'post', service+"/updateExamBasicQuery" , params ,contentTYPE_JSON)}

//更新用户EMC信息
export const updateExamEmc = ( params ) => { return req( 'post', service+"/updateExamEmc" , params ,contentTYPE_JSON)}

//更新新版用户EMC信息
export const updateExamEmcNew = ( params ) => { return req( 'post', service+"/updateExamEmcNew" , params ,contentTYPE_JSON)}

//更新用户心电信息
export const updateExamEcg = ( params ) => { return req( 'post', service+"/updateExamEcg" , params ,contentTYPE_JSON)}

//更新用户HyperQ信息
export const updateExamHyperq = ( params ) => { return req( 'post', service+"/updateExamHyperq" , params ,contentTYPE_JSON)}

//更新用户HyperQRest信息
export const updateExamHyperqRest = ( params ) => { return req( 'post', service+"/updateExamHyperqRest" , params ,contentTYPE_JSON)}

///web/api/ExamService/updateExamState/{examUuid}/{examStat}
//更新当前检查状态
export const updateExamState = ( params ) => { return req( 'post', service+"/updateExamState" + "/" + params )}

//更新处方
export const updateExamPrescription = (params, data) => { return req( 'post', service+"/updateExamPrescription" + "/" + params ,data,contentTYPE_JSON)}

//上传文件  params = "examUuid/bsp"
///web/api/ExamService/uploadFile/{examUuid}/{fileType}
export const uploadFile = ( params , data ) => { return req( 'post', service+"/uploadFile" + '/' + params , data )}

export const exportData = ( params ) => { return reqPostForDownload( 'post', service+"/exportExcel" + '/' + params)}
